/**
 * Kundlogotyper och kontaktfoton: var kopian i Firebase Storage ligger och
 * vilken bild exporten ska använda. Ren logik utan Firebase, så att den går
 * att testa. Själva kopieringen görs i bildkopia.js (webbläsaren) och
 * scripts/backfill-bildkopior.js (befintliga bilder).
 *
 * Fält:
 *   crmCompanies/{id}                 logoUrl   extern adress (LinkedIn via EnrichLayer m.fl.)
 *                                     logoPath  kopian i Storage, 'kunder/{id}/logo.jpg'
 *                                     logoKalla logoUrl som kopian gjordes från
 *   crmCompanies/{k}/contacts/{id}    photoUrl, photoPath ('kontakter/{id}/foto.jpg'), photoKalla
 *
 * Kopian gäller bara så länge logoKalla är samma som logoUrl. Byts eller
 * töms bilden räknas kopian som inaktuell.
 */

/** Största sida på kopian i Storage, i px. */
export const BILDKOPIA_MAX_PX = 256;

export const BILDFALT = {
  logo: { url: 'logoUrl', path: 'logoPath', kalla: 'logoKalla' },
  foto: { url: 'photoUrl', path: 'photoPath', kalla: 'photoKalla' },
};

export const kundLoggaPath = kundId => `kunder/${kundId}/logo.jpg`;
export const kontaktFotoPath = kontaktId => `kontakter/${kontaktId}/foto.jpg`;

/** http(s)-adress, inte en Storage-sökväg. */
export function arExternUrl(url) {
  return typeof url === 'string' && /^https?:\/\//i.test(url.trim());
}

/** Storage-kopian om den är gjord från nuvarande bild, annars ''. */
export function sparadSokvag(dok, typ) {
  const f = BILDFALT[typ];
  if (!dok || !dok[f.path] || !dok[f.url]) return '';
  return dok[f.kalla] === dok[f.url] ? dok[f.path] : '';
}

/** Ska bilden kopieras till Storage? Extern adress utan aktuell kopia. */
export function behoverKopia(dok, typ) {
  const f = BILDFALT[typ];
  return arExternUrl(dok?.[f.url]) && !sparadSokvag(dok, typ);
}

/**
 * Vad exporten hämtar bilden från: Storage-sökvägen om kopian är aktuell,
 * annars den externa adressen, annars ''.
 */
export function exportBildkalla(dok, typ) {
  const sparad = sparadSokvag(dok, typ);
  if (sparad) return sparad;
  const url = dok?.[BILDFALT[typ].url];
  return arExternUrl(url) ? url.trim() : '';
}
